import { getDisplayUrl, type PlanType } from "@/stores/user-store";
import type { Asset } from "@/types";
import type { AssetFilterType } from "@/components/features/assets";

/**
 * Utility functions for asset display and filtering
 */

export function mapAssetForDisplay(asset: Asset, plan: PlanType) {
  return {
    ...asset,
    type: asset.media_type.toLowerCase() as "video" | "image",
    title:
      asset.prompt ||
      (asset.source === "upload"
        ? undefined
        : `${asset.media_type} ${asset.source}`),
    thumbnail: getDisplayUrl(asset, plan),
    isFavorite: asset.is_favorite,
    createdAt: asset.created_at,
    dimensions: { width: asset.width, height: asset.height },
  };
}

export function filterAssets(
  assets: Asset[],
  filter: AssetFilterType,
): Asset[] {
  switch (filter) {
    case "all":
      return assets;
    case "favorites":
      return assets.filter((a) => a.is_favorite);
    case "video":
      return assets.filter(
        (a) => a.media_type === "VIDEO" && a.source === "generation",
      );
    case "image":
      return assets.filter(
        (a) => a.media_type === "IMAGE" && a.source === "generation",
      );
    // Characters tab is rendered via CharacterGrid (its own data path),
    // not the generic asset list. This case is unreachable at runtime
    // but keeps the AssetFilterType record contract complete.
    case "characters":
      return [];
    default:
      return assets;
  }
}
